// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import store from './store'
import axios from 'axios'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import Fingerprint2 from './utils/Fingerprint2'
import {quickLogin} from './api/api'
import {createA} from './utils/utils'

Vue.use(VueAwesomeSwiper)
Vue.use(ElementUI)

Vue.config.productionTip = false
Vue.prototype.$axios = axios
axios.defaults.withCredentials = true

new Fingerprint2().get(function (result, components) {
  window.token = result
  localStorage.setItem('fp', window.token)
  console.log(window.token)
})

async function preInit () {
  console.log(window.location.href.includes('='))
  if (window.location.href.includes('=')) {
    let token = window.location.href.split('=')[1]
    token = token.replaceAll('%20', ' ')
    console.log(token, '22222')
    let params = {
      token: token.replaceAll('%20', ' ')
    }
    const res = await quickLogin(params)
    console.log(res)
    if (res.code == 0) {
      localStorage.setItem('user', JSON.stringify(res.result))
      localStorage.setItem('token', JSON.stringify(res.result.token))
      createA('/xgyz')
    }
  }
}
async function start () {
  await preInit()
  /* eslint-disable no-new */
  window._vm = new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>'
  })
}
start()



// WEBPACK FOOTER //
// ./src/main.js